import React from 'react';
import { Icon, Button } from 'components';
import { useSelect, useAction } from 'hooks';
import { withForm, withFormValidation } from 'hoc';
import { get } from 'lodash';
import { Link, useHistory } from 'react-router-dom';

const initState = {
  email: ''
}

function ForgotPassword({ value, onChange, isPassed }) {
  const history = useHistory()
  const isLoading = useSelect('loading.isLoading', { type: 'auth.forgotPassword' })
  const forgotPassword = useAction('auth.forgotPassword')

  const handleSubmit = e => {
    e.preventDefault()
    forgotPassword(value.email, () => {
      history.push('/')
    })
  }

  const handleBack = e => {
    e.preventDefault()
    history.push('/login')
  }

  return (
    <div className="login-container">
      <div className="form-container">
        <form className="form w-full flex flex-grow" onSubmit={handleSubmit}>
          <div className="xl:!hidden lg:!hidden flex flex-col items-center justify-center flex-grow">
            <Icon.Logo className="lw-36 h-36"/>
            <span className="text-xs text-center">Land Transportation Franchising & Regulatory Board</span>
            <span className="text-sm font-bold text-center">Online Application and Issuance of Certificate of Public Convenience</span>
          </div>
          <div className="hidden xl:flex lg:flex flex-grow justify-center">
            <Icon.Logo className="lw-36 h-36"/>
            <div className="content space-x-2 flex items-center ml-auto">
              <button type="button" onClick={handleBack} className="btn !w-auto !px-2 bg-white border-red-600 border"><b className="text-blue-700 px-4">Back</b></button>
            </div>
          </div>
          <div className="flex items-center xl:!pb-16 pb-5">
            <Link to="/forgot-password" className="w-full h-16 flex text-black items-center justify-start rounded-none border-b-4 border-warning"><span className="xl:!text-2xl lg:text-xl text-sm font-bold">Forgot Password</span></Link>

          </div>
          <div className="account-input-container">
            <label className="label">Email Address:</label>
            <input
              autoComplete='off'
              type="text"
              name="email"
              onChange={onChange}
              value={get(value, 'email')}
            />
          </div>
          <Button
            isLoading={isLoading}
            // disabled={!isPassed}
            className="!bg-warning !rounded-none !text-black h-12 xl:!mt-16 mt-5"
          >
            <span>Submit</span>
          </Button>
          <Link to="/" className="forgot-password-link">Sign In</Link>
        </form>
      </div>
      <div className="brand xl:!flex lg:!flex !hidden">
        <div className="content">
          <span className="title">Land Transportation Franchising & Regulatory Board</span>
          <span className="sub-title">Online Application and Issuance of Certificate of Public Convenience</span>
        </div>
      </div>
    </div>
  );
}


export default withForm(withFormValidation(ForgotPassword,
  {
    email: 'required|email'
  },
), initState);
